import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

import Button from '../../Components/Button';
import Footer from '../../Components/Footer';
import Navbar from '../../Components/Navbar';
import Homespeeches from './Homespeeches';
import Landingpage from './Landingpage';
import Producthome from './producthome';

import styles from './Home.module.css';

export default function Home() {
  const [currentLanguage] = useState(() => {
    return localStorage.getItem('siteLanguage') || 'fa';
  });

  const isFa = currentLanguage === 'fa';
  const siteUrl = 'https://nasrollah.info'; 
  const pageUrl = siteUrl;
  const pageImage = `${siteUrl}/assets/images/og-home.jpg`;

  // Dynamic SEO configurations
  const pageTitle = isFa
    ? 'پایگاه نشر آثار عالم مجاهد شهید سیدحسن نصرالله'
    : 'منصة نشر أفكار وآثار المجاهد الشهيد السيد حسن نصرالله';

  const pageDescription = isFa
    ? 'پایگاه نشر اندیشه‌ها و آثار عالم مجاهد، حجةالاسلام‌والمسلمین شهید سیدحسن نصرالله دام عزّه '
    : 'موقع نشر لأفكار وأعمال العالم المجاهد، شهيد الإسلام والمسلمين، السيد حسن نصر الله، رحمه الله.';

  const siteName = 'nasrollah.info';
  const langCode = isFa ? 'fa-IR' : 'ar';
  const ogLocale = isFa ? 'fa_IR' : 'ar_AR';

  // Schema.org Structured Data (WebSite + Organization)
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: siteName,
        description: pageDescription,
        inLanguage: langCode,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: siteName,
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/assets/images/logo.png`,
        },
      },
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: pageTitle,
        description: pageDescription,
        inLanguage: langCode,
        isPartOf: {
          '@id': `${siteUrl}/#website`,
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        {/* Core Metadata */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta httpEquiv="content-language" content={langCode} />
        <meta name="author" content={siteName} />

        {/* Canonical Link */}
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={ogLocale} />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:image:alt" content={pageTitle} />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImage} />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Navbar />
    <Landingpage />
    {currentLanguage === 'fa' ? (
    <>
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.section}>
          {/* <span></span> */}
          <h1>بيانات</h1>
        </div>
        <p>در این بخش، سخنرانی‌های شهيد سيد حسن نصرالله را خواهید خواند این مجموعه شامل بیش از سه دهه (32 سال) سخنرانی‌های ایشان در حوزه‌های متنوعی همچون سیاست، دین، عرفان و مباحث اندیشه‌ای است. این سخنرانی‌ها که بخش مهمی از میراث فکری ایشان را تشکیل می‌دهد، در طول دوران تصدی ایشان به‌عنوان دبیرحزب الله ایراد شده و این مسیر تا زمان شهادت ایشان ادامه یافته است. مطالعه‌ی این متون، دریچه‌ای به سوی اندیشه‌ها و دغدغه‌های ایشان در طول سالیان متمادی فعالیتشان خواهد بود.</p>
        <Link to='/Speeches'>
          <Button />
        </Link>
      </div>
    </div>
    <Homespeeches />
        <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.section}>
          {/* <span></span> */}
          <h2>توليدات</h2>
        </div>
        <p>در این بخش، مجموعه‌ای از محصولات صوتی و تصویری برگزیده از سخنرانی‌های شهيد سيد حسن نصرالله گردآوری و عرضه شده است. این محصولات شامل کلیپ‌های کوتاه و گزینش‌شده‌ای از بیانات ایشان است که در قالب ویدیوهایی با روایت صدای خود ایشان تهیه و تدوین شده‌اند. هر یک از این کلیپ‌ها، لحظاتی ناب و تأثیرگذار از اندیشه‌ها و رهنمودهای ایشان را در حوزه‌های سیاست، دین، عرفان و مباحث اندیشه‌ای در بر می‌گیرد و برای استفاده در فضای مجازی، پژوهش و یا بازنشر فرهنگی مناسب است. این مجموعه، تلاشی است برای حفظ و نشر میراث گران‌بهای فکری ایشان در قالبی کوتاه و جذاب</p>
        <Link to='/productions'>
          <Button />
        </Link>
      </div>
    </div>
    <Producthome />
    <Footer />
    </>
    ) : (
  // arabic part
    <>
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.section}>
          {/* <span>روتر</span> */}
          <h1>الإنتاجات</h1>
        </div>
        <p>يستعرض هذا القسم مجموعة مختارة بعناية من المواد السمعية والبصرية التي تتضمن خطابات للشهيد السيد حسن نصر الله. وتتألف هذه المواد من مقاطع قصيرة مُنتقاة   لتوثيق لحظات عميقة ومؤثرة تعكس رؤاه وتوجيهاته حول السياسة والدين والروحانيات والطروحات الفكرية. وتُعد هذه المواد ملائمة للاستخدام عبر وسائل التواصل الاجتماعي، أو في الأبحاث، أو لأغراض النشر الثقافي؛ إذ تمثل هذه المجموعة جهداً يهدف إلى حفظ إرثه الفكري القيّم ومشاركته من خلال صيغة موجزة وجذابة </p>
        <Link to='/productions'>
          <Button />
        </Link>
      </div>
    </div>
    <Producthome />
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.section}>
          {/* <span>روتر</span> */}
          <h1>خطابات</h1>
        </div>
        <p>في هذا القسم، ستجدون خطابات الشهيد السيد حسن نصر الله. وتضم هذه المجموعة خطاباتٍ تغطي أكثر من ثلاثة عقود (32 عاماً)، وتتناول مواضيع متنوعة تشمل السياسة والدين والعرفان والطروحات الفكرية. وقد أُلقيت هذه الخطابات -التي تشكل جزءاً هاماً من إرثه الفكري- خلال فترة توليه منصب الأمين العام لحزب الله، وهو المنصب الذي شغله حتى نيله الشهادة؛ وتتيح دراسة هذه النصوص نافذةً للاطلاع على أفكاره والقضايا التي طبعت مسيرته الحافلة بالنشاط على مدى سنوات طويلة.</p>
        <Link to='/Speeches'>
          <Button />
        </Link>
      </div>
    </div>
    <Homespeeches />
    <Footer />
  </>
)} 
    </>
)}